import {
  validationErrorCodes as ERROR,
  serverErrorCodes as SERROR
} from './errorCodes';
import { hasError } from './getError';

export const getErrorMessage = (error, passThrough = true) => {
  if (Array.isArray(error) && !error.length) return '';
  switch (true) {
    case hasError(error, SERROR.OTP_CODE_INVALID):
      return 'Invalid authentication code';
    case hasError(error, SERROR.INVITE_TOKEN_INVALID_ERROR):
      return 'Invitation is not valid';
    case hasError(error, SERROR.INVITE_TOKEN_ACCEPTED_ERROR):
      return 'Invitation is no longer valid';
    case hasError(error, SERROR.INVITE_USER_DATA_ERROR):
      return 'Required user data was not provided';
    case hasError(error, SERROR.ATTRIBUTE_UNIQUE_CONSTRAINT):
    case hasError(error, SERROR.DUPLICATE_NAME):
      return 'This name has already been taken. Please use a unique name.';
    case hasError(error, ERROR.ERROR_REQUIRED):
    case hasError(error, ERROR.REQUIRED_ERROR):
      return 'This field is required';
    case hasError(error, ERROR.EMAIL_SYNTAX_ERROR):
      return 'Invalid email address';
    case hasError(error, ERROR.SHOULD_MATCH_VALUE):
      return 'Fields do not match';
    case hasError(error, ERROR.DUPLICATE_RECIPIENTS_ERROR):
      return 'Duplicate recipients are not allowed';
    case hasError(error, ERROR.INVALID_RECIPIENTS_ERROR):
      return 'Invalid email used';

    default:
      return !passThrough
        ? 'Something went wrong. Please contact support@cube-cloud.com'
        : errorToString(error);
    // : typeof error === 'string'
    // ? error
    // : typeof error[0] === 'string'
    // ? error[0]
    // : error._error && error._error[0]
    // ? error._error[0].detail
    // : error.title || error.detail || (error.code?.code ?? error.code);
  }
};

const errorToString = (error) => {
  try {
    if (!error) return '';
    if (typeof error === 'string') return error;
    if (typeof error === 'number' || typeof error === 'boolean')
      return error.toString();

    if (Array.isArray(error)) {
      const err = error[0];
      if (typeof err === 'string') return err;
      return errorToString(err);
    }
    if (typeof error === 'object') {
      const err = error._error || error.detail || error.title || error.code;
      if (typeof err === 'string') return err;
      return errorToString(err);
    }
    return String(error);
  } catch (e) {
    return '[Unable to convert to string]' + error;
  }
};

export const getReadableErrors = (errors, passThrough = true) => {
  if (!errors) return undefined;
  if (Array.isArray(errors)) {
    if (!errors.length) return undefined;
    return errors.map((err) => getErrorMessage(err, passThrough));
  }
  return getErrorMessage(errors, passThrough);
};

export function getErrors(errorMessage: string, metaError: string) {
  return errorMessage
    ? errorMessage
    : metaError !== undefined
    ? [].concat(metaError)
    : metaError;
}
